module.exports = __webpack_public_path__ + "static/media/michaelFrank21.f081a7f8.png";